import { FirestoreDataConverter } from "firebase/firestore";
import { ProductDisplay } from "lib-shared-code";
import { PartialConverter } from "../types";
import { genericConverter } from "./generic-converter";

export const productDisplayConverter: FirestoreDataConverter<ProductDisplay> &
  PartialConverter<ProductDisplay> = genericConverter<ProductDisplay>();
